/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Members_Confirm_Reset_DescriptionInputs */



/**
* | output |
* | --- |
* | "Reset credentials for {email}? They will need to use a new setup token to access their account." |
*
* @param {Members_Confirm_Reset_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_confirm_reset_description = /** @type {((inputs: Members_Confirm_Reset_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Confirm_Reset_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Anmeldeinformationen für ${i?.email} zurücksetzen? Sie benötigen einen neuen Einrichtungs-Token, um auf ihr Konto zuzugreifen.`)
	return /** @type {LocalizedString} */ (`Reset credentials for ${i?.email}? They will need to use a new setup token to access their account.`)
});